import { ICcbVinculoEncerrado, IVinculoEncerradoRetorno } from "@/models/consignado/proposal-billings.model";
import { hidratarCcbAtivo } from "../VinculosAtivosRedesign/hidratarCcbAtivo";

// Linha REAL de GET /cobrancas/vinculos-encerrados = a linha do ativo + a badge
// de elegibilidade ao seguro (classificada no backend).
export const hidratarCcbEncerrado = (row: IVinculoEncerradoRetorno): ICcbVinculoEncerrado => ({
  ...hidratarCcbAtivo(row),
  elegibilidade_seguro: row.elegibilidade_seguro,
  motivos_nao_elegibilidade: row.motivos_nao_elegibilidade,
  dias_desde_desligamento: row.dias_desde_desligamento,
  valor_parcela: row.valor_parcela,
});
